import { render, staticRenderFns } from "./ResourceAdminTable.vue?vue&type=template&id=64cdcb02&"
import script from "./ResourceAdminTable.vue?vue&type=script&lang=js&"
export * from "./ResourceAdminTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/staging.portal.letsreimagine.org/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64cdcb02')) {
      api.createRecord('64cdcb02', component.options)
    } else {
      api.reload('64cdcb02', component.options)
    }
    module.hot.accept("./ResourceAdminTable.vue?vue&type=template&id=64cdcb02&", function () {
      api.rerender('64cdcb02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/resources/ResourceAdminTable.vue"
export default component.exports